import { createTheme, responsiveFontSizes } from "@mui/material";

let theme = createTheme({
  palette: {
    primary: {
      main: "#1b5b46", //teal
    },
    secondary: {
      main: "#1b8b7f", //teal
    },
    background: {
      default: "#fafafa", //teal
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif", // Add your preferred font here
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          textTransform: "none",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);
export default theme;
